import { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Box, Typography } from '@mui/material';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export default function ScoreChart({ labels, data, title = 'Tendencia de Score' }) {
  const chartData = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: 'Score',
          data,
          borderColor: '#111827',
          backgroundColor: 'rgba(17, 24, 39, 0.06)',
          fill: true,
          tension: 0.4,
          pointRadius: 3,
          pointBackgroundColor: '#111827',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
        },
      ],
    }),
    [labels, data]
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { mode: 'index', intersect: false },
    },
    scales: {
      x: {
        grid: { color: '#f3f4f6' },
        ticks: { color: '#6b7280', font: { size: 11 } },
      },
      y: {
        min: 0,
        max: 100,
        grid: { color: '#f3f4f6' },
        ticks: { stepSize: 20, color: '#6b7280', font: { size: 11 } },
      },
    },
  };

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: 3,
        p: 3,
        border: '1px solid #e5e7eb',
        borderRadius: 4,
        bgcolor: '#ffffff',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontFamily: '"Cal Sans", "Inter", sans-serif',
          fontWeight: 600,
          letterSpacing: '0.02em',
          color: '#111827',
          mb: 2,
          fontSize: 18,
        }}
      >
        {title}
      </Typography>
      <Box sx={{ height: 280 }}>
        <Line data={chartData} options={options} />
      </Box>
    </Box>
  );
}
